(function () {
  function moneyFromCard(card) {
    var label = card.querySelector('[data-kit-price-label]');
    return label ? label.textContent.trim() : '';
  }

  function itemFromCard(card) {
    var price = parseFloat(card.getAttribute('data-price') || '0') || 0;
    return {
      item_id: card.getAttribute('data-sku') || card.getAttribute('data-variant-id') || '',
      item_name: card.getAttribute('data-item-name') || '',
      item_brand: 'Santi The Sloth',
      item_category: 'Baby Routine Kits',
      item_variant: card.getAttribute('data-item-variant') || card.getAttribute('data-kit-key') || '',
      price: price,
      quantity: 1
    };
  }

  function pushDataLayer(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
    document.dispatchEvent(new CustomEvent('santi-mini:' + eventName, { detail: payload || {} }));
  }

  function setButtonState(button, stateText, disabled) {
    if (!button) return;
    if (!button.getAttribute('data-original-text')) {
      button.setAttribute('data-original-text', button.textContent.trim());
    }
    button.textContent = stateText || button.getAttribute('data-original-text');
    button.disabled = !!disabled;
  }

  function itemFromAddon(tile) {
    var price = parseFloat(tile.getAttribute('data-price') || '0') || 0;
    return {
      item_id: tile.getAttribute('data-sku') || tile.getAttribute('data-variant-id') || '',
      item_name: tile.getAttribute('data-item-name') || '',
      item_brand: 'Santi The Sloth',
      item_category: 'Santi Mini Add-ons',
      item_variant: tile.getAttribute('data-item-variant') || '',
      price: price,
      quantity: 1
    };
  }

  function setAddonTileState(tile, stateText, disabled, stateClass) {
    if (!tile) return;
    var addButton = tile.querySelector('[data-addon-add]');
    var label = tile.querySelector('[data-addon-action-label]');
    var available = tile.getAttribute('data-available') === 'true';

    if (label && !label.getAttribute('data-original-text')) {
      label.setAttribute('data-original-text', label.textContent.trim());
    }

    if (label) {
      label.textContent = stateText || label.getAttribute('data-original-text');
    }

    if (addButton) addButton.disabled = !!disabled || !available;
    tile.classList.toggle('is-added', stateClass === 'added');
    tile.classList.toggle('is-error', stateClass === 'error');
  }

  function selectedOption(select) {
    if (!select || select.selectedIndex < 0) return null;
    return select.options[select.selectedIndex];
  }

  function syncAddonVariant(tile) {
    if (!tile) return;
    var select = tile.querySelector('[data-addon-variant-select]');
    var option = selectedOption(select);
    if (!option) return;

    var available = option.getAttribute('data-available') === 'true';
    var addLabel = tile.getAttribute('data-add-label') || 'Add to cart';
    var priceLabel = option.getAttribute('data-price-label') || '';
    var actionLabel = tile.querySelector('[data-addon-action-label]');

    tile.setAttribute('data-variant-id', option.value || '');
    tile.setAttribute('data-sku', option.getAttribute('data-sku') || '');
    tile.setAttribute('data-item-variant', option.getAttribute('data-title') || '');
    tile.setAttribute('data-price-cents', option.getAttribute('data-price-cents') || '');
    tile.setAttribute('data-price', option.getAttribute('data-price') || '');
    tile.setAttribute('data-available', available ? 'true' : 'false');

    if (actionLabel) {
      actionLabel.textContent = available ? addLabel + ' · ' + priceLabel : 'Currently unavailable';
      actionLabel.setAttribute('data-original-text', actionLabel.textContent.trim());
    }

    setAddonTileState(tile, null, false);
  }

  function syncKitVariant(card) {
    if (!card) return;
    var select = card.querySelector('[data-kit-variant-select]');
    var option = selectedOption(select);
    if (!option) return;

    var available = option.getAttribute('data-available') === 'true';
    var currentPrice = card.querySelector('[data-kit-price-current]');
    var comparePrice = card.querySelector('[data-kit-price-compare]');
    var stockLabel = card.querySelector('[data-kit-stock-label]');

    card.setAttribute('data-variant-id', option.value || '');
    card.setAttribute('data-sku', option.getAttribute('data-sku') || '');
    card.setAttribute('data-item-variant', option.getAttribute('data-title') || '');
    card.setAttribute('data-price-cents', option.getAttribute('data-price-cents') || '');
    card.setAttribute('data-price', option.getAttribute('data-price') || '');
    card.setAttribute('data-available', available ? 'true' : 'false');
    card.classList.toggle('is-unavailable', !available);

    if (currentPrice) currentPrice.textContent = option.getAttribute('data-price-label') || '';
    if (comparePrice) {
      var compareLabel = option.getAttribute('data-compare-at-label') || '';
      comparePrice.textContent = compareLabel;
      comparePrice.hidden = compareLabel === '';
    }
    if (stockLabel) {
      stockLabel.textContent = available
        ? (stockLabel.getAttribute('data-available-label') || 'Available')
        : (stockLabel.getAttribute('data-unavailable-label') || 'Currently unavailable');
    }

    Array.prototype.slice.call(card.querySelectorAll('[data-kit-add]')).forEach(function (button) {
      button.disabled = !available;
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart refresh failed');
        return response.json();
      })
      .then(function (cart) {
        var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
        if (count === null) return cart;

        Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]')).forEach(function (countElement) {
          countElement.textContent = count;
        });

        Array.prototype.slice.call(document.querySelectorAll('[data-cart-count-bubble]')).forEach(function (bubble) {
          bubble.classList.toggle('hide', count <= 0);
        });

        return cart;
      });
  }

  function openCartDrawerAfterAdd() {
    if (window.SantiCartDrawer && typeof window.SantiCartDrawer.open === 'function') {
      return window.SantiCartDrawer.open({ autoClose: true }).catch(function () {});
    }

    return refreshCartCount().catch(function () {});
  }

  function initAddonTiles() {
    var tiles = Array.prototype.slice.call(document.querySelectorAll('[data-santi-mini-addon]'));

    tiles.forEach(function (tile) {
      var addButton = tile.querySelector('[data-addon-add]');
      var variantSelect = tile.querySelector('[data-addon-variant-select]');

      syncAddonVariant(tile);

      if (variantSelect) {
        variantSelect.addEventListener('click', function (event) {
          event.stopPropagation();
        });
        variantSelect.addEventListener('change', function () {
          syncAddonVariant(tile);
        });
      }

      if (!addButton) return;

      addButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        syncAddonVariant(tile);

        var variantId = tile.getAttribute('data-variant-id');
        var available = tile.getAttribute('data-available') === 'true';
        if (!variantId || !available) return;

        setAddonTileState(tile, 'Adding...', true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1,
            properties: {
              '_Santi Mini add-on': tile.getAttribute('data-item-name') || ''
            }
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart add failed');
            return response.json();
          })
          .then(function () {
            var item = itemFromAddon(tile);
            pushDataLayer('add_to_cart', {
              currency: tile.getAttribute('data-currency') || 'AUD',
              value: item.price,
              ecommerce: { items: [item] }
            });
            return openCartDrawerAfterAdd();
          })
          .then(function () {
            setAddonTileState(tile, 'Added', false, 'added');
            window.setTimeout(function () {
              setAddonTileState(tile, null, false);
            }, 1800);
          })
          .catch(function () {
            setAddonTileState(tile, 'Try again', false, 'error');
          });
      });
    });
  }

  function initKitSelector(selector) {
    var cards = Array.prototype.slice.call(selector.querySelectorAll('[data-kit-card]'));
    var sticky = selector.querySelector('[data-santi-mini-sticky-atc]');
    var stickyTitle = sticky ? sticky.querySelector('[data-sticky-title]') : null;
    var stickyPrice = sticky ? sticky.querySelector('[data-sticky-price]') : null;
    var stickyButton = sticky ? sticky.querySelector('[data-sticky-add]') : null;
    var redirectToCart = selector.getAttribute('data-redirect-to-cart') === 'true';
    var selectedCard = cards.filter(function (card) {
      return card.classList.contains('is-selected');
    })[0] || cards[0];

    function selectCard(card, shouldTrack) {
      if (!card) return;
      selectedCard = card;
      cards.forEach(function (candidate) {
        var isSelected = candidate === card;
        candidate.classList.toggle('is-selected', isSelected);
        var selectButton = candidate.querySelector('[data-kit-select]');
        if (selectButton) selectButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      if (stickyTitle) stickyTitle.textContent = card.getAttribute('data-item-name') || '';
      if (stickyPrice) stickyPrice.textContent = moneyFromCard(card);
      if (stickyButton) stickyButton.disabled = card.getAttribute('data-available') !== 'true';

      if (shouldTrack) {
        var item = itemFromCard(card);
        pushDataLayer('select_item', {
          item_list_id: 'santi_mini_kit_selector',
          item_list_name: 'Santi Mini Kit Selector',
          currency: card.getAttribute('data-currency') || 'AUD',
          value: item.price,
          ecommerce: { items: [item] }
        });
      }
    }

    function addSelectedKit(button) {
      if (!selectedCard) return;
      var variantId = selectedCard.getAttribute('data-variant-id');
      var available = selectedCard.getAttribute('data-available') === 'true';
      if (!variantId || !available) return;

      var buttons = [button].concat(Array.prototype.slice.call(selectedCard.querySelectorAll('[data-kit-add]')));
      buttons.forEach(function (btn) { setButtonState(btn, 'Adding...', true); });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          properties: {
            '_Santi Mini kit': selectedCard.getAttribute('data-item-variant') || selectedCard.getAttribute('data-kit-key') || ''
          }
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(function () {
          var item = itemFromCard(selectedCard);
          pushDataLayer('add_to_cart', {
            currency: selectedCard.getAttribute('data-currency') || 'AUD',
            value: item.price,
            ecommerce: { items: [item] }
          });
          return openCartDrawerAfterAdd();
        })
        .then(function () {
          buttons.forEach(function (btn) { setButtonState(btn, 'Added', false); });
          window.setTimeout(function () {
            buttons.forEach(function (btn) { setButtonState(btn, null, false); });
          }, 1800);
          if (redirectToCart) {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          buttons.forEach(function (btn) { setButtonState(btn, 'Try again', false); });
        });
    }

    cards.forEach(function (card) {
      var selectButton = card.querySelector('[data-kit-select]');
      var addButtons = Array.prototype.slice.call(card.querySelectorAll('[data-kit-add]'));
      var variantSelect = card.querySelector('[data-kit-variant-select]');

      syncKitVariant(card);

      if (variantSelect) {
        variantSelect.addEventListener('click', function (event) {
          event.stopPropagation();
        });
        variantSelect.addEventListener('change', function () {
          syncKitVariant(card);
          if (selectedCard === card) selectCard(card, false);
        });
      }

      if (selectButton) {
        selectButton.addEventListener('click', function () {
          selectCard(card, true);
        });
      }
      addButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          selectCard(card, true);
          addSelectedKit(button);
        });
      });
    });

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        addSelectedKit(stickyButton);
      });
    }

    if (sticky) {
      var stickyTrigger = selector.querySelector('[data-kit-grid]') || selector;
      var updateSticky = function () {
        var selectorRect = selector.getBoundingClientRect();
        var triggerRect = stickyTrigger.getBoundingClientRect();
        var isDesktop = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
        var hasEnteredKitSelector = selectorRect.top <= Math.min(160, window.innerHeight * 0.22);
        var isBeforeKitSectionEnd = selectorRect.bottom > 80;
        var isAfterKitGrid = triggerRect.bottom < 0;
        sticky.classList.toggle('is-visible', !isDesktop && isBeforeKitSectionEnd && (hasEnteredKitSelector || isAfterKitGrid));
      };
      updateSticky();
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
    }

    selectCard(selectedCard, false);
  }

  function initMiniOnlyForms() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('[data-santi-mini-interest-form]'));
    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        pushDataLayer('generate_lead', {
          method: 'mini_only_interest',
          source: 'santi_mini_launch_page',
          content_group: 'Santi Mini'
        });
      });
    });
  }

  function initAnchorLinks() {
    var page = document.querySelector('[data-santi-mini-page]');
    if (!page) return;

    var links = Array.prototype.slice.call(page.querySelectorAll('a[href^="#"]'));
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var targetId = link.getAttribute('href');
        if (!targetId || targetId === '#') return;

        var target = document.querySelector(targetId);
        if (!target) return;

        event.preventDefault();

        var header = document.querySelector('.site-header');
        var headerOffset = header ? header.getBoundingClientRect().bottom : 0;
        var targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;

        window.scrollTo({
          top: Math.max(0, targetTop),
          behavior: 'smooth'
        });

        if (window.history && window.history.pushState) {
          window.history.pushState(null, '', targetId);
        }
      });
    });
  }

  function initReviewPaging() {
    var widgets = Array.prototype.slice.call(document.querySelectorAll('[data-santi-mini-review-pager]'));

    widgets.forEach(function (widget) {
      var perPage = parseInt(widget.getAttribute('data-reviews-per-page'), 10) || 4;
      var currentPage = 1;
      var controls = null;
      var status = null;
      var pageLabel = null;
      var previousButton = null;
      var nextButton = null;

      function getReviews() {
        return Array.prototype.slice.call(widget.querySelectorAll('.jdgm-rev'));
      }

      function getReviewTotal(reviews) {
        var header = widget.querySelector('.jdgm-all-reviews__header');
        var declaredTotal = header ? parseInt(header.getAttribute('data-number-of-reviews') || header.getAttribute('data-number-of-product-reviews'), 10) : 0;
        return Math.max(reviews.length, declaredTotal || 0);
      }

      function ensureControls() {
        if (controls) return;

        controls = document.createElement('div');
        controls.className = 'santi-mini-review-pager';
        controls.setAttribute('data-santi-mini-review-controls', '');
        controls.innerHTML = [
          '<p class="santi-mini-review-pager__status" data-review-page-status></p>',
          '<div class="santi-mini-review-pager__buttons">',
          '<button type="button" data-review-page-prev>Previous</button>',
          '<span data-review-page-label></span>',
          '<button type="button" data-review-page-next>Next</button>',
          '</div>'
        ].join('');

        status = controls.querySelector('[data-review-page-status]');
        pageLabel = controls.querySelector('[data-review-page-label]');
        previousButton = controls.querySelector('[data-review-page-prev]');
        nextButton = controls.querySelector('[data-review-page-next]');

        previousButton.addEventListener('click', function () {
          currentPage = Math.max(1, currentPage - 1);
          renderReviews();
        });

        nextButton.addEventListener('click', function () {
          var reviews = getReviews();
          var totalPages = Math.ceil(getReviewTotal(reviews) / perPage);
          currentPage = Math.min(totalPages, currentPage + 1);
          renderReviews();
        });

        widget.appendChild(controls);
      }

      function renderReviews() {
        var reviews = getReviews();
        if (!reviews.length) return false;

        ensureControls();

        var reviewTotal = getReviewTotal(reviews);
        var totalPages = Math.max(1, Math.ceil(reviewTotal / perPage));
        currentPage = Math.min(currentPage, totalPages);

        var start = (currentPage - 1) * perPage;
        var end = start + perPage;

        if (start >= reviews.length && reviews.length > 0) {
          currentPage = Math.max(1, Math.ceil(reviews.length / perPage));
          start = (currentPage - 1) * perPage;
          end = start + perPage;
        }

        reviews.forEach(function (review, index) {
          var isVisible = index >= start && index < end;
          review.hidden = !isVisible;
          review.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        });

        widget.classList.add('is-compact');

        if (status) {
          status.textContent = 'Showing ' + (start + 1) + '-' + Math.min(end, reviewTotal) + ' of ' + reviewTotal + ' reviews';
        }
        if (pageLabel) {
          pageLabel.textContent = 'Page ' + currentPage + ' of ' + totalPages;
        }
        if (previousButton) {
          previousButton.disabled = currentPage <= 1;
        }
        if (nextButton) {
          nextButton.disabled = currentPage >= totalPages;
        }

        if (controls) {
          controls.hidden = totalPages <= 1;
        }

        return true;
      }

      var attempts = 0;
      var interval = window.setInterval(function () {
        attempts += 1;
        if (renderReviews() || attempts > 20) {
          window.clearInterval(interval);
        }
      }, 250);

      var observer = new MutationObserver(function () {
        window.setTimeout(renderReviews, 80);
      });

      observer.observe(widget, { childList: true, subtree: true });
    });
  }

  function initCreatorCarousels() {
    var carousels = Array.prototype.slice.call(document.querySelectorAll('[data-santi-mini-creator-carousel]'));

    carousels.forEach(function (carousel) {
      var rail = carousel.querySelector('[data-creator-rail]');
      var previousButton = carousel.querySelector('[data-creator-prev]');
      var nextButton = carousel.querySelector('[data-creator-next]');
      if (!rail) return;

      var isLooping = false;
      var isAdjustingLoop = false;
      var loopStart = 0;
      var loopEnd = 0;
      var loopWidth = 0;
      var scrollFrame = null;

      function getCards(includeClones) {
        var selector = includeClones ? '.santi-mini-creator-card' : '.santi-mini-creator-card:not([data-creator-clone])';
        return Array.prototype.slice.call(rail.querySelectorAll(selector));
      }

      function getRailPaddingLeft() {
        var styles = window.getComputedStyle(rail);
        return parseFloat(styles.paddingLeft || '0') || 0;
      }

      function getStep() {
        var card = getCards(true)[0];
        var styles = window.getComputedStyle(rail);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card ? card.getBoundingClientRect().width + gap : 320;
      }

      function maxScroll() {
        return Math.max(0, rail.scrollWidth - rail.clientWidth);
      }

      function createLoopClone(card, position) {
        var clone = card.cloneNode(true);
        clone.setAttribute('data-creator-clone', position);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.querySelectorAll('[id]').forEach(function (element) {
          element.removeAttribute('id');
        });
        clone.querySelectorAll('a, button, input, select, textarea, video, [tabindex]').forEach(function (element) {
          element.setAttribute('tabindex', '-1');
        });
        clone.querySelectorAll('video').forEach(function (video) {
          video.pause();
          video.controls = false;
          video.setAttribute('preload', 'none');
        });
        return clone;
      }

      function measureLoop() {
        var originalCards = getCards(false);
        var firstOriginal = originalCards[0];
        var firstAfterClone = rail.querySelector('[data-creator-clone="after"]');
        if (!firstOriginal || !firstAfterClone) return;

        loopStart = Math.max(0, firstOriginal.offsetLeft - getRailPaddingLeft());
        loopWidth = Math.max(0, firstAfterClone.offsetLeft - firstOriginal.offsetLeft);
        loopEnd = loopStart + loopWidth;
      }

      function setupInfiniteLoop() {
        var existingClones = Array.prototype.slice.call(rail.querySelectorAll('[data-creator-clone]'));
        existingClones.forEach(function (clone) {
          clone.parentNode.removeChild(clone);
        });

        var originalCards = getCards(false);
        if (originalCards.length < 2) return;

        var beforeFragment = document.createDocumentFragment();
        var afterFragment = document.createDocumentFragment();

        originalCards.forEach(function (card) {
          beforeFragment.appendChild(createLoopClone(card, 'before'));
          afterFragment.appendChild(createLoopClone(card, 'after'));
        });

        rail.insertBefore(beforeFragment, originalCards[0]);
        rail.appendChild(afterFragment);
        rail.classList.add('is-infinite');
        isLooping = true;
        measureLoop();
      }

      function normaliseLoopPosition() {
        if (!isLooping || isAdjustingLoop || loopWidth <= 0) return;

        var currentScroll = rail.scrollLeft;
        if (currentScroll < loopStart) {
          isAdjustingLoop = true;
          rail.scrollLeft = currentScroll + loopWidth;
          isAdjustingLoop = false;
        } else if (currentScroll >= loopEnd) {
          isAdjustingLoop = true;
          rail.scrollLeft = currentScroll - loopWidth;
          isAdjustingLoop = false;
        }
      }

      function updateButtons() {
        var max = maxScroll();
        var isScrollable = max > 8;
        carousel.classList.toggle('is-scrollable', isScrollable);

        if (previousButton) previousButton.disabled = !isScrollable;
        if (nextButton) nextButton.disabled = !isScrollable;
      }

      function scrollByCard(direction) {
        normaliseLoopPosition();
        rail.scrollBy({
          left: getStep() * direction,
          behavior: 'smooth'
        });
        window.setTimeout(normaliseLoopPosition, 420);
      }

      function setInitialPeek() {
        if (rail.getAttribute('data-initial-peek-set') === 'true' || maxScroll() <= 8) return;
        measureLoop();
        var startingPosition = isLooping ? loopStart : 0;
        rail.scrollLeft = Math.min(startingPosition + (getStep() * 0.5), maxScroll());
        rail.setAttribute('data-initial-peek-set', 'true');
        updateButtons();
      }

      if (previousButton) {
        previousButton.addEventListener('click', function () { scrollByCard(-1); });
      }
      if (nextButton) {
        nextButton.addEventListener('click', function () { scrollByCard(1); });
      }

      rail.addEventListener('scroll', function () {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(function () {
          scrollFrame = null;
          normaliseLoopPosition();
          updateButtons();
        });
      }, { passive: true });

      window.addEventListener('resize', function () {
        window.setTimeout(function () {
          measureLoop();
          normaliseLoopPosition();
          updateButtons();
        }, 100);
      });

      window.requestAnimationFrame(function () {
        setupInfiniteLoop();
        setInitialPeek();
        updateButtons();
      });

      window.setTimeout(function () {
        setInitialPeek();
        updateButtons();
      }, 500);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-santi-mini-kit-selector]')).forEach(initKitSelector);
    initAddonTiles();
    initMiniOnlyForms();
    initAnchorLinks();
    initReviewPaging();
    initCreatorCarousels();
  });
})();
